defineCustomVueElement('csb-compatibility-checker', {
  name: 'Compatibility Checker',
  template: `<div class="compatibility-check">
    <div v-if="groupCompatibilityDecoded.length == 0" class="compatible-no-data">Generic - no compatibility data</div>
    <div v-else-if="csbStore.currentModel == null" class="compatible-not-selected">No model selected, use selector to verify compatibility</div>
    <div v-else-if="isCompatible && isStandard" class="compatible-compatible">
      <div class="page-width">
        <span v-if="pageType == 'collection'">&#10004; Products in this category ARE compatible with your {{ csbStore.currentModel.brand + ' ' + csbStore.currentModel.name }}</span>
        <span v-else>&#10004; This product IS compatible with your {{ csbStore.currentModel.brand + ' ' + csbStore.currentModel.name }}</span>
      </div>
    </div>
    <div v-else-if="isCompatible" class="compatible-non-standard">
      <div class="page-width">
        <span v-if="pageType == 'collection'">&#10004; Products in this category ARE compatible with your {{ csbStore.currentModel.brand + ' ' + csbStore.currentModel.name }}, but may require a sprocket change</span>
        <span v-else>&#10004; This product IS compatible with your {{ csbStore.currentModel.brand + ' ' + csbStore.currentModel.name }}, but may require a sprocket change</span>
      </div>
    </div>
    <div v-else class="compatible-not-compatible">
      <div class="page-width">
        <span v-if="pageType == 'collection'">&#10006; Products in this category ARE NOT compatible with your {{ csbStore.currentModel.brand + ' ' + csbStore.currentModel.name }}</span>
        <span v-else>&#10006; This product IS NOT compatible with your {{ csbStore.currentModel.brand + ' ' + csbStore.currentModel.name }}</span>
      </div>
    </div>
  </div>`,
  props: {
    pageType: { default: null },
    productType: { default: null },
    groupCompatibility: { default: [] },
    chainSpec: { default: [] }
  },
  data() {
    return {
      chainSpecDecoded: [],
      groupCompatibilityDecoded: [],
      csbStore: useCsbStore()
    }
  },
  computed: {
    isStandard() {
      if (this.csbStore.currentModel.chain_spec == null || this.chainSpecDecoded.length == 0) {
        return true
      }
      return this.csbStore.currentModel == null ? false : this.chainSpecDecoded.includes(this.csbStore.currentModel.chain_spec)
    },
    isCompatible() {
      return this.csbStore.currentModel == null ? false : this.groupCompatibilityDecoded.includes(this.csbStore.currentModel.sub_group)
    }
  },
  async mounted() {
    this.chainSpecDecoded = JSON.parse(this.chainSpec)
    this.groupCompatibilityDecoded = JSON.parse(this.groupCompatibility)
    await this.csbStore.init()
  }
}, { plugins: [ piniaStore ] })